import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { Location } from '@remix-run/router/history';

interface initialStateInterface {
  location: Location | null;
}

const initialState: initialStateInterface = {
  location: null,
};

/**
 * Router reducer
 *
 * This is a replacement for the connectRouter reducer from connected-react-router
 */
const routerSlice = createSlice({
  name: 'router',
  initialState: initialState,
  reducers: {
    locationChange(state, action: PayloadAction<Location | null>) {
      state.location = action.payload;
    },
  },
});

export const locationChange = routerSlice.actions.locationChange;

export default routerSlice;
